import React, {useState, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {Card, Carousel, Col, Button, OverlayTrigger, Tooltip} from 'react-bootstrap'
import StreamgraphChart from './components/StreamgraphChart'
import StreamgraphChart2 from './components/StreamgraphChart2'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
interface ItemType {
  id: number
  title: string
  campaigns: number
  logo: string
  bgColor: string
}

const DashboardPage = () => {
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row g-5 g-xl-8'>
          <Card className='mb-8'>
            <div className='card'>
              <Card.Body className='row' style={{marginTop: '-35px'}}>
                <StreamgraphChart />
                <p className='card-text source mt-2 row'>
                  <i style={{fontSize: '12px'}} className='mb-2'>
                    * The baseline represents the smoothed value from the previous year. Confidence
                    intervals are calculated by determining the critical value using the normal
                    distribution corresponding to a 95% confidence level. The standard deviation is
                    multiplied by this critical value to obtain the margins of error, which are then
                    added and subtracted from the sample mean to define the interval bounds. The
                    computed alert corresponds to a binary value of 0/1 for each week, diagnosis,
                    age group, geographical origin or/and RSS duration. It indicates, when equal to
                    1, that the current case count exceeds the upper bound of the baseline case
                    count.
                  </i>
                  <i>
                    Source:
                    <a className='fw-bold' href='https://www.rki.de/EN/Home/homepage_node.html'>
                      {' '}
                      Robert Koch-Institut
                    </a>
                  </i>{' '}
                </p>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

const DashboardPage2 = () => {
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row g-5 g-xl-8'>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <h2 className='text-primary bold'>
                  {' '}
                  Deaths in patients with a diagnosis of respiratory syndroms (France – private
                  Hospital)
                </h2>

                <p className='card-text p-2 bg-secondary rounded'>
                  Some quick example text to build on the card title and make up the bulk of the
                  card's content.
                </p>
              </div>
              <Card.Body className='row'>
                <StreamgraphChart2 />
                <p className='card-text source'>
                  <img
                    className='mb-1'
                    style={{width: '12px'}}
                    alt='logo'
                    src={toAbsoluteUrl('/media/logos/ii.svg')}
                  />
                  <i>Source: Hospices Civils de Lyon, Résumés de Sortie Standardisés (RSS)</i>
                </p>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

const DeathsForRespiratory = () => {
  const intl = useIntl()
  return (
    <>
      <div className='mb-5'>
        <DashboardPage />
      </div>
      {/* <div  className='mb-5'>
        <DashboardPage2 />
        </div> */}
    </>
  )
}

export {DeathsForRespiratory}
